import {CompanyTypeArray} from "@mytour/shared";
import type {UseFormReturn} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {FormGroup, Input, Label} from "reactstrap";
import type {Step1Form} from "./Step1";

type Props = {
  hookForm: UseFormReturn<Step1Form>;
  // Called when the user explicitly changes the legal form (not on programmatic
  // setValue). Lets the auto-fill variant know the user has taken ownership.
  onPicked?: () => void;
};

export function CompanyTypeSelect({hookForm, onPicked}: Props) {
  const {t: translate} = useTranslation();
  const {
    register,
    formState: {errors},
  } = hookForm;

  const error = errors?.companyType;
  const {
    onChange: superOnChange,
    onBlur,
    ref,
  } = register("companyType", {
    required: translate("entity.validation.required"),
  });

  return (
    <FormGroup>
      <Label id={"companyTypeLabel"} for={"companyTypeLabel"}>
        {translate("myTourApp.platformUser.companyType")}
        {" *"}
      </Label>
      <Input
        className="form-control"
        name="companyType"
        onBlur={onBlur}
        innerRef={ref}
        onChange={async (e) => {
          onPicked?.();
          await superOnChange(e);
        }}
        type="select"
        id="platform-user-company-type"
        invalid={Boolean(error)}
      >
        <option value="">--</option>
        {CompanyTypeArray.map((companyType) => (
          <option value={companyType} key={companyType}>
            {companyType}
          </option>
        ))}
      </Input>
      {error && <div className="invalid-feedback">{handleValidate()}</div>}
    </FormGroup>
  );

  function handleValidate(): string | undefined {
    if (error?.message && typeof error.message === "string") {
      return error.message;
    }
  }
}
